import { cn } from '../../lib/cn.ts'
import { RallyLoader } from './rally-loader.tsx'
import { useDelayedLoading } from './use-delayed-loading.ts'

export interface PanelLoaderProps {
  /** The full phrase, stating what is being restored: "Reading publishing ledger". */
  label: string
  /** Roughly what the arrived content will take, so nothing shifts when it lands. */
  minHeight?: number
  className?: string
}

// RAL-182's panel-load surface: the md mark centred in the box a request is filling, no hairline
// and no wordmark. Self-gated — the box reserves its height from the first frame but the mark
// only appears once the 300ms gate elapses, so a fast request shows no loader at all.
//
// The 500ms minimum hold and the 200ms exit still can't apply: every call site unmounts this the
// moment its data lands. Tracked in RAL-190; this is the one place that fix will need to land.
export function PanelLoader({ label, minHeight, className }: PanelLoaderProps) {
  const show = useDelayedLoading(true)

  return (
    <div className={cn('flex items-center justify-center px-5 py-4', className)} style={{ minHeight }}>
      {show ? <RallyLoader size="md" label={label} /> : <span className="sr-only">{label}</span>}
    </div>
  )
}
